import React from 'react';
import Header from './Home/Header';

const Navigation = () => {
  return <Header />;
};

export default Navigation;
